import { lazy } from "react";

const CasinoHomePage = lazy(() => import("./pages/home/index.jsx"));
const CasinoProviderPage = lazy(() => import("./pages/provider/index.jsx"));
const CasinoFavoritesPage = lazy(() => import("./pages/favorites/index.jsx"));
const CasinoGameplayPage = lazy(() => import("./pages/gameplay/index.jsx"));

export { CasinoFavoritesPage, CasinoGameplayPage, CasinoHomePage, CasinoProviderPage };
